import { render } from "./SchoolCategories.vue?vue&type=template&id=5243700e&scoped=true"
import script from "./SchoolCategories.vue?vue&type=script&lang=js"
export * from "./SchoolCategories.vue?vue&type=script&lang=js"

import "./SchoolCategories.vue?vue&type=style&index=0&id=5243700e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5243700e"]])

export default __exports__